import React from 'react';

export default function ProfileDropdown({ onLogout }) {

  const name = localStorage.getItem('name') || 'User';
  const email = localStorage.getItem('email') || 'user@example.com';

  return (
    <div className="relative group inline-block">
      <img
        src="/images/default_avatar.png" 
        alt="Profile"
        className="w-10 h-10 rounded-full block align-middle object-cover"
      />
      <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
        <div className="p-4 text-sm border-b">
          <p className="font-medium truncate">{name}</p>
          <p className="text-gray-500 text-xs mt-1 truncate">{email}</p>
        </div>
            <button
            onClick={onLogout}
            className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
            >
                Logout
            </button>
      </div>
    </div>
  );
}
